import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import PowerlistHeader from '../Powerlist/PowerlistHeader';
import Layout from './Layout';

const queryClient = new QueryClient();

// if hitting the page as non subscriber, show locked homepage and only render header
const EnterprisePowerlist = ({
  isUnlocked = true,
  offerCode,
}: {
  isUnlocked?: boolean;
  offerCode?: string;
}) => {
  return (
    <QueryClientProvider client={queryClient}>
      {isUnlocked ? <Layout /> : <PowerlistHeader isUnlocked={isUnlocked} offerCode={offerCode} />}
    </QueryClientProvider>
  );
};

export default EnterprisePowerlist;
